import { useState, useEffect } from "react"
import { FiltersDrawerIdCardsProps } from "../components/FiltersDrawerIdCards"

const useActiveFiltersCount = (filters: FiltersDrawerIdCardsProps) => {
    const [activeCounts, setActiveCounts] = useState({ cardActive: 0, debtorActive: 0, userActive: 0 })

    useEffect(() => {
        const countActiveFilters = (conditions: any[]) => conditions.filter(Boolean).length
        const cardActiveCount = countActiveFilters([filters.cardType, filters.cardNumber, filters.isInActive])
        const debtorActiveCount = countActiveFilters([filters.customerId])
        const userActiveCount = countActiveFilters([filters.email, filters.employeeId])

        setActiveCounts({
            cardActive: cardActiveCount,
            debtorActive: debtorActiveCount,
            userActive: userActiveCount,
        })
    }, [filters])

    const totalActiveCount = Object.values(activeCounts).reduce((sum, count) => sum + count, 0)

    return {
        activeCount: totalActiveCount,
        ...activeCounts,
    }
}

export default useActiveFiltersCount
